module.exports = __webpack_public_path__ + "static/media/bin-trip-analysis-slide.1f34f915.jpg";